module.exports = __webpack_public_path__ + "img/thumbnail_PallasCat_m_erythristic.04011424.png";